import { Button, Modal, Spin } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { post, get } from '../../Common/api'
import EventForm from './EventForm'
import { Color } from '../../Common/Color'
import { WarningOutlined } from '@ant-design/icons'

const UnresolvedEvent = ({ events }) => {
  const navigate = useNavigate()

  const Content = ({ events }) => {
    return events.map(event => (
      <li key={event.id} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red, fontSize: '0.8em' }}
        onClick={() => navigate(`/admin/events/${event.id}`)} >
        {event.title}
      </li>
    ))
  }
  return (
    <>
      <div style={{ fontWeight: 'bold', textAlign: 'center', margin: '1em' }}>
        {t('Admin.Event.list')}
      </div>
      <ul style={{ padding: '1em' }}>
        <Content events={events} />
      </ul>
    </>
  )
}

export default function CreateEventCard ({ box, slot, minimized = false }) {
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [events, setEvents] = useState([])
  const [form] = useForm()
  const navigate = useNavigate()

  const getEvents = async () => {
    setLoading(true)
    await get('admin/events', { box_id: box.id, slot_id: slot.id }, (res) => {
      setLoading(false)
      setEvents(res.events)
    }, () => {
      setLoading(false)
    })
  }

  useEffect(() => {
    if (slot?.id) {
      getEvents()
    }
  }, [box, slot])

  const onClick = () => {
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    setLoading(true)
    await post('admin/events', values, (response) => {
      setModalVisible(false)
      navigate(`/admin/events/${response.event.id}`)
    })
  }

  return (
    <>
      <Modal
        open={modalVisible}
        width="800px"
        title={t('Admin.Event.title.create')}
        okText={t('actions.validate')}
        confirmLoading={loading}
        onOk={form.submit}
        onCancel={() => setModalVisible(false)}
      >
        <Spin spinning={loading}>
          <EventForm form={form} onFinish={onAdd} slotId={slot?.id} boxId={box?.id} />
        </Spin>
      </Modal>
      {minimized && <Button type="primary" size="large" icon={<WarningOutlined />} onClick={onClick} className='hoverable'
        style={{ '--hover-color': Color.red, boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)', border: '1px solid darkgrey' }} />
      }
      {!minimized &&
        <div style={{
          boxShadow: '0px 0px 2px 2px #f2f2f2',
          borderRadius: '1em',
          padding: '1em',
          margin: '1em',
          maxWidth: '290px',
          fontSize: '1.2em',
          textAlign: 'center'
        }}>
          <div style={{ fontWeight: 'bold' }}>
            {t('Admin.Event.create')}
            <br/>
            {box?.teleconsulting_company}
          </div>

          <Button style={{ marginTop: '0.5em' }} onClick={onClick} type="primary" icon={<WarningOutlined />}>
            {t('Admin.Event.createButton')}
          </Button>
        </div>
      }
      <Spin spinning={loading}>
        {!minimized && events.length > 0 &&
          <div style={{
            boxShadow: '0px 0px 2px 2px #f2f2f2',
            borderRadius: '1em',
            padding: '0.1em',
            margin: '0.1em',
            maxWidth: '290px',
            fontSize: '1.2em'
          }}>
            <UnresolvedEvent events={events} />
          </div>
        }
      </Spin>
    </>
  )
}
